import * as React from "react";
import ActivityIcon from "../ativityIcons/ActivityIcon";

interface IProps {
	/**
	 * Stream header icon.
	 */
	icon: string;
	/**
	 * Stream header icon background color.
	 */
	color: IconColor;
	/**
	 * Stream header icon color variant.
	 */
	variant?: "white" | "orange" | "green";
}

export default class StreamItemIcon extends React.Component<IProps, {}> {
	render() {
		return (
			<div className={"m-stream-item_icon"}>
				<ActivityIcon icon={this.props.icon} color={this.props.color} variant={this.props.variant}/>
				<div className={"m-stream-item_icon_line"}/>
			</div>
		);
	}
}

export enum IconColor {
	Orange = "orange",
	Yellow = "yellow",
	Green = "green",
	NoteYellow = "noteYellow",
	Burgundy = "burgundy",
	Blue = "blue",
	White = "white"
}